import { newTraderDiary } from '../../constants/initialStates'
import { ReduxAction } from '../../types/common'
import { CREATE_MASS_TRADER_DIARIES, EXPORT_TRADER_DIARIES, GET_TRADER_DIARIES, UPDATE_TRADER_DIARIES_DIARY, UPDATE_TRADER_DIARY_STATE } from '../actionTypes'

export interface TraderDiaryByStateCount {
  count: number
  state: string
}

export interface TraderDiaryTableRow {
  traderDiaryId: number
  businessTerritoryId: number
  creationDate: Date
  amount: number
  quantity: number
  price: number
  state: string

  clientId: number
  clientFirstname: string
  clientSurname: string
  companyName: string
  securityName: string
  isin: string
  instrumentType: string
  symbol: string
  ticker: string
  assetClass: string

  orderDirection: string
  validityType: string
  validity: string
  orderType: string
  orderMarketType: string

  currency: string
  securityId: number
  methodReceiving: string

  diary: boolean,
  diaryExported: boolean

  portfolio: {
    currency: string | null
    name: string | null
    portfolioId: Number | null
    firstIndicatorDate: null
    lastIndicatorDate: null
  }
  userId: number
}

export interface TraderDiary {
  traderDiaryId: number
  businessTerritoryId: number
  creationDate: string | Date | null
  amount: number | null
  quantity: number | null
  price: number | null
  state: string | null

  portfolioId: number

  orderDirection: string
  validityType: string
  validity: Date | null
  orderType: string
  orderMarketType: string

  currency: string | null
  securityId: number | null
  methodReceiving: string

  diary: boolean,
  diaryExported: boolean

  portfolio: {
    currency: string | null
    name: string | null
    portfolioId: Number | null
    firstIndicatorDate: null
    lastIndicatorDate: null
  }

  clientId: number

  attachments: number | null

  cpty: { cptyId:number, name: string }
  marketName: string
  brokerName: string

  orderComment: string | null
  internalComment: string | null
  fee: number | null
  errorDescription: string | null
  settleDirectly: boolean | null
  userId: number | null

  isID: boolean | null

  cptyId: number
  cptyName: string
}

interface TraderDiaryState {
  traderDiaries: TraderDiaryTableRow[]
  traderDiariesByStateCount: TraderDiaryByStateCount[]
  traderDiary: TraderDiary
}

const INITIAL_STATE = {
  traderDiaries: [],
  traderDiariesByStateCount: [],
  traderDiary: newTraderDiary,
}


export const traderDiaries = (state: TraderDiaryState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case GET_TRADER_DIARIES:
      return {
        ...state,
        traderDiaries: action.payload as TraderDiaryTableRow[],
      }
    case UPDATE_TRADER_DIARIES_DIARY:
      let newDiaries=[...state.traderDiaries];
      if ( newDiaries ) {
        for ( let i=0; i<newDiaries.length; i++) {
          if (  newDiaries[i].traderDiaryId===action.payload.traderDiaryId ) {
            newDiaries[i].diary = action.payload.diaryValue;
            break;
          }
        }
      }
      return {
        ...state,
        traderDiaries: newDiaries
      }

    case EXPORT_TRADER_DIARIES:
      let exportedDiaries=[...state.traderDiaries];
      if ( exportedDiaries && action.payload ) {
        for ( let i=0; i<exportedDiaries.length; i++ ) {
          for ( let j=0; j<action.payload.length; j++ ) {
            if ( exportedDiaries[i].traderDiaryId === action.payload[j] ) {
              exportedDiaries[i].diaryExported = true;
              break;
            }
          }
        }
      }
      return {
        ...state,
        traderDiaries: exportedDiaries
      }
    case CREATE_MASS_TRADER_DIARIES:
      let tmp = action.payload as TraderDiaryTableRow[];
      return {
        ...state, traderDiaries: tmp.concat(state.traderDiaries)
      }
    case UPDATE_TRADER_DIARY_STATE:
      let updateDiaries=[...state.traderDiaries];
      if ( updateDiaries ) {
        for ( let i=0; i<updateDiaries.length; i++) {
          if (  updateDiaries[i].traderDiaryId===action.payload.traderDiaryId ) {
            updateDiaries[i].state = 'TD_CANCELED'
            break
          }
        }
      }
      return {
        ...state,
        traderDiaries: updateDiaries
      }
    default:
      return state
  }
}
